import { memo, useContext } from 'react';
import { ProductContext } from '../context';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChatAndQuestions = function ChatAndQuestions() {
  var _useContext = useContext(ProductContext),
      setShowAskQuestion = _useContext.setShowAskQuestion;

  var onAskAQuestion = function onAskAQuestion() {
    setShowAskQuestion(true);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.questions,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.titleSmall,
      children: "Have questions relating to our product fit, fabric or sizing?"
    }), /*#__PURE__*/_jsx("button", {
      className: css.askAQuestion,
      onClick: onAskAQuestion,
      type: "button",
      children: "Ask A Question"
    })]
  });
};

export default /*#__PURE__*/memo(ChatAndQuestions);